import React, { Component } from 'react'
// import { Switch, Route, Redirect } from 'react-router-dom'
import MainViewHolder from './views/MainViewHolder'
import PropTypes from 'prop-types'
import withStyles from '@material-ui/core/styles/withStyles'
// import { createBrowserHistory } from 'history'
// import { Router } from 'react-router-dom';
import { composeWithDevTools } from 'redux-devtools-extension';
import { LocalizeProvider, localizeReducer } from 'react-localize-redux';
import { createStore, combineReducers } from 'redux';

class Main extends Component {

    render(){

        return (

            <LocalizeProvider store={this.getReduxStore()}>
                <MainViewHolder/> 
            </LocalizeProvider>

        )

    }

    getReduxStore() {
        return createStore(combineReducers({ 
          localize: localizeReducer
        }), composeWithDevTools());
      }

}

const styles = theme => ({

    container: {
        display: 'flex',
        minHeight: '100vh',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
    },
    footer: {
        position:'fixed',
        left:0,
        right:0,
        bottom:-5,
        zIndex: 9
      },
    footerImge: {
        width: '100%',
        height: 130
    },
    footerImageMobile: {
        width:'100%',
        height: 50
    }

})

Main.propsTypes = {
    classes: PropTypes.object.isRequired
}

export default withStyles(styles) (Main);